import { type CompletionStrategyProviderOffer, type ProviderOffer } from "../../../../../types/dtos/api/sales/provider-offer.dto";
import { type OfferPricingEvaluationContext, type ProviderPricingEvaluation } from "../OfferPricing.types";
import { BaseOfferPricingProvider } from "../OfferPricingProvider.contract";

export class CompletionStrategyOfferPricingProvider extends BaseOfferPricingProvider {

    /**
     * Creates the completion-strategy pricing provider plugin.
     */
    public constructor() {
        super( "completion_strategy" );
    }

    /**
     * Returns provider-only metadata because completion strategy offers do not carry direct prices.
     *
     * @param _ Segment context (unused for this provider).
     * @param providerOffer Raw provider payload.
     * @returns Normalized provider evaluation with no price and no booking URL.
     */
    public evaluate( _: OfferPricingEvaluationContext, providerOffer: ProviderOffer ): ProviderPricingEvaluation {
        const typedOffer = providerOffer as CompletionStrategyProviderOffer;

        return {
            "providerKey":  typedOffer.provider,
            "providerName": this.getProviderLabel(),
            "price":        null,
            "bookingUrl":   null,
        };
    }

}

export const completionStrategyOfferPricingProviderPlugin = new CompletionStrategyOfferPricingProvider();
